<template>
  <div>
    <div v-for='(row,index) in rows' :key='index'>
      <div v-if='index<limit' :class="['plan-item',progressStatusMap[row.progress_status]]" draggable='true'
           @dragend='dragend' @dblclick='handleDetail(row)' @dragstart='dragstart(row)'
           @contextmenu.prevent.stop='rightClick($event,row)'>
        <el-tooltip class="item" effect="light"
                    :content="`发起人：${row.leader_name},美护选品:${row.lb_product_count},服饰选品：${ row.lb_dress_selection_count},视频号：${row.lb_video_selection_count}`"
                    placement="top">
          <span class="plan-item-content">
            <img v-if='platformsIcon(row.platform_code)'
                 :src='platformsIcon(row.platform_code)'/> {{ row.nickname || '' }}
            {{ row.platform_name || '' }}
          </span>
        </el-tooltip>
      </div>
    </div>
    <Contextmenu :menu-data='menuData' :id='currentId' @change='handleCmd'/>
  </div>
</template>

<script>
import Contextmenu from './Contextmenu.vue'

export default {
  name: 'KolCalendarPanel',
  components: {Contextmenu},
  props: {
    item: {
      type: Object,
      default() {
        return {data: {}}
      }
    },
    showLimit: {
      type: Boolean,
      default() {
        return true
      }
    },
    platforms: {
      type: [Object, Array],
      default() {
        return {data: {}}
      }
    },
    limitValue: {
      type: Number,
      default() {
        return 4
      }
    }
  },
  computed: {
    rows() {
      return this.item ? this.item.data : []
    },
    limit() {
      if (this.showLimit) {
        return this.limitValue
      } else {
        return this.rows.length
      }
    },
    currentId() {
      return this.currentRow ? this.currentRow.id : null
    },
    progressStatusMap() {
      const map = {}
      this.progressStatusOptions.forEach((item) => {
        map[item.value] = item.class_name
      })
      return map
    },


  },
  data() {
    return {
      menuData: {
        visible: false,
        top: 0,
        left: 0
      },
      currentRow: {},
      dragData: {},
      progressStatusOptions: [
        {label: '新创建', value: 1, color_value: '#ffffff', class_name: 'status-new'},
        {label: '已发需求', value: 2, color_value: '#67C23A', class_name: 'status-launch'},
        {label: '初选完成', value: 3, color_value: '#409EFF', class_name: 'status-original'},
        {label: '确认完成', value: 4, color_value: '#E6A23C', class_name: 'status-ack'},
        {label: '锁定表格', value: 5, color_value: '#F56C6C', class_name: 'status-lock'}
      ]
    }
  },
  methods: {
    platformsIcon(code) {
      const obj = this.platforms.find(value => value.code === code)
      return obj ? obj.logo_url : null
    },
    dragend() {
      if (this.dragData != {}) {
        this.$emit('handleDrag', this.dragData)
      }
    },
    dragstart(data) {
      this.dragData = data
    },
    rightClick(e, row) {
      this.currentRow = row
      e.preventDefault()

      this.menuData = {
        visible: true,
        left: e.clientX,
        top: e.clientY
      }
      document.addEventListener('click', this.closeMenu)
    },
    closeMenu(e) {
      if (e.target.className.indexOf('contextmenu__item') === -1) {
        this.menuData.visible = false
        document.removeEventListener('click', this.closeMenu)
      }
    },
    handleCmd(cmd) {
      this.$emit('handleCmd', cmd, this.currentRow)
    },
    handleDetail(currentRow) {
      this.$emit('handleCmd', 'detail', currentRow)
    }

  }
}
</script>

<style lang="scss" scoped>
@import "../../style/main.scss";

.plan-item {
  line-height: 1.2;
  //border: #7d8086 1px solid;
  cursor: pointer;
  width: 95%;
  overflow-x: hidden;
  text-align: left;
  border-radius: 6px;
  white-space: nowrap;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: 24px;
  margin: 2px auto 1px;
}

.plan-item:hover {

  background-color: #f5f7fa;
}

.plan-item img {
  width: 24px;
  height: 24px;
  margin-right: 10px;
  vertical-align: middle;
}

.plan-item-content {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  font-size: 14px;
  padding: 0.3vh;
}

.plan-item-content :hover {
  font-size: 16px;
}

.unselect {
  color: #F56C6C;
}

</style>
